import { useEffect, useState, useRef } from 'react';
import { getStatusColor, getChipTextColor } from '../../../../utils/utilFunctions';
import { Tooltip, Chip } from '@mui/material';

const StatusTooltip = ({ cellValues }) => {
	const [isOverflowing, setIsOverflowing] = useState(false);
	const cardRowRef = useRef(null);
	useEffect(() => {
		if (cardRowRef.current) {
			setIsOverflowing(cardRowRef.current.scrollWidth < 130);
		}
	}, [cellValues]);

	return (
		<Tooltip arrow placement="top" title={isOverflowing ? `${cellValues?.formattedValue}` : ''}>
			<Chip
				ref={cardRowRef}
				data-testid={`${cellValues?.field}-${cellValues?.id}`}
				label={cellValues?.formattedValue}
				sx={{
					backgroundColor: getStatusColor(cellValues?.formattedValue),
					color: getChipTextColor(cellValues?.formattedValue)
				}}
				size="small"
			/>
		</Tooltip>
	);
};

export default StatusTooltip;
